import type { DrawerItem } from '@/components/subject/configs.ts';

const experiments: DrawerItem[] = [
  // {
  //   title: '2.导数在函数中的基本运用',
  //   icon: 'lucide:folder',
  //   children: [
  //     { title: '导数辅助工具', icon: 'lucide:flask-conical', route: `/experiment/derivative-basic` },
  //   ],
  // },
];

const experimentConfig = {
  experiments,
};

export { experimentConfig };
